import { Box, SimpleGrid } from "@chakra-ui/react";
import { Search } from "lucide-react";
import { useCallback } from "react";

import DebouncedInput from "@/components/DebouncedInput";
import SelectFilter from "@/components/SelectFilter";

import type { OrgBillFiltersType } from "../types/filters.type";

const BILL_STATUS_OPTIONS = ["Sin pagar", "Pagado"];

type Props = {
  queryFilters: OrgBillFiltersType;
  setQueryFilters: React.Dispatch<React.SetStateAction<OrgBillFiltersType>>;
};

const OrgBillFilters = ({
  queryFilters,
  setQueryFilters,
}: Props): JSX.Element => {
  const handleSelectStatus = useCallback(
    (status: string | undefined) =>
      setQueryFilters((prev) => ({ ...prev, status })),
    [setQueryFilters]
  );

  const handleMerchantChange = useCallback(
    (merchant: string) => setQueryFilters((prev) => ({ ...prev, merchant })),
    [setQueryFilters]
  );

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} gap={3} mb={4}>
      <Box position="relative">
        <Box
          position="absolute"
          right={3}
          top="50%"
          transform="translateY(-50%)"
          zIndex={1}
        >
          <Search size={16} />
        </Box>
        <DebouncedInput
          size="sm"
          placeholder="Comercio"
          _placeholder={{ color: "#5D5C60" }}
          value={queryFilters.merchant}
          onDebouncedChange={handleMerchantChange}
        />
      </Box>
      <SelectFilter
        isClearable
        options={BILL_STATUS_OPTIONS}
        selectedOption={queryFilters.status}
        onSelect={handleSelectStatus}
        placeholder="Estado"
      />
    </SimpleGrid>
  );
};

export default OrgBillFilters;
